import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=15b64929"
import script from "./CardList.vue?vue&type=script&lang=ts"
export * from "./CardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b64929')) {
      api.createRecord('15b64929', component.options)
    } else {
      api.reload('15b64929', component.options)
    }
    module.hot.accept("./CardList.vue?vue&type=template&id=15b64929", function () {
      api.rerender('15b64929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/CardList.vue"
export default component.exports